import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const OfferDetailPdf = ({ logoStr, data }) => {
  const styles = StyleSheet.create({
    page: {
      padding: 30,
      fontFamily: "Roboto",
    },
    section: {
      marginBottom: 10,
    },
    header: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    offerNoContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
      alignItems: "flex-end",
    },
    titleContainer: {
      display: "flex",
      flexDirection: "column",
      marginBottom: 20,
      justifyContent: "flex-end",
      alignItems: "flex-end",
    },
    logo: {
      maxWidth: 140,
    },
    title: {
      fontSize: 20,
      fontWeight: "bold",
    },
    text: {
      fontSize: 9,
      marginBottom: 5,
    },
    table: {
      marginBottom: 20,
    },
    tableHeader: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
      borderBottomStyle: "solid",
      marginBottom: 5,
    },
    tableRow: {
      flexDirection: "row",
      marginBottom: 5,
      borderBottomColor: "gray",
      borderBottomStyle: "solid",
      borderBottomWidth: 0.5,
    },
    tableCell: {
      flex: 1,
      fontSize: 10,
      padding: 5,
    },
    footer: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginTop: 20,
    },
    signatorySection: {
      marginTop: 30,
      flexDirection: "row",
      justifyContent: "space-between",
    },
    signatory: {
      width: "30%",
      textAlign: "center",
    },
    signatureText: {
      fontSize: 12,
      marginTop: 10,
      borderTopWidth: 1,
      borderTopColor: "#000",
      borderTopStyle: "solid",
      paddingTop: 5,
    },
    logoPlaceholder: {
      fontSize: 20,
      color: "grey",
      fontWeight: "bold",
      textAlign: "center",
    },
  });

  const formatDate = (dateString) => {
    const tarihObjesi = new Date(dateString);
    const gun = tarihObjesi.getDate();
    const ay = tarihObjesi.getMonth() + 1;
    const yil = tarihObjesi.getFullYear();
    return `${gun}/${ay}/${yil}`;
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.logoContainer}>
            {logoStr ? (
              <Image src={logoStr} style={styles.logo} />
            ) : (
              <Text style={styles.logoPlaceholder}>LOGO</Text>
            )}
          </View>
          <View style={styles.offerNoContainer}>
            <View style={styles.titleContainer}>
              <Text style={styles.title}>TEKLİF</Text>
              <Text style={styles.title}>{data?.offerNo} </Text>
            </View>
            <Text style={styles.text}>
              Tarih: {formatDate(data?.offerDate)}
            </Text>
            <Text style={styles.text}>
              Geçerlilik Tarihi: {formatDate(data?.expiryDate)}
            </Text>
            <Text style={styles.text}>
              Termin Tarihi: {data.deadLine ? formatDate(data?.deadLine) : "Belirtilmemiş"}
            </Text>
          </View>
        </View>

        <View style={styles.section}>
          <Text style={[styles.text, { fontWeight: "bold" }]}>
            Cari: {data?.account?.name}
          </Text>
          <Text style={styles.text}>Vergi Dairesi: {data?.taxOffice}</Text>
          <Text style={styles.text}>Vergi No: {data?.taxNumber}</Text>
          <Text style={styles.text}>Adres: {data?.address}</Text>
          <Text style={styles.text}>Tel No: {data?.account?.telephone}</Text>
          <Text style={styles.text}>E-mail: {data?.account?.email}</Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.tableCell}>Ürün Adı</Text>
            <Text style={styles.tableCell}>Miktar</Text>
            <Text style={styles.tableCell}>Birim Fiyatı</Text>
            <Text style={styles.tableCell}>Birim Tipi</Text>
            <Text style={styles.tableCell}>Vergi Fiyatı</Text>
            <Text style={styles.tableCell}>Vergi Oranı</Text>
            <Text style={styles.tableCell}>Toplam Fiyat</Text>
          </View>
          {data?.offerItems.map((item, index) => (
            <View key={index} style={styles.tableRow}>
              <Text style={styles.tableCell}>{item.name}</Text>
              <Text style={styles.tableCell}>{item.quantity}</Text>
              <Text style={styles.tableCell}>{item.unitPrice}</Text>
              <Text style={styles.tableCell}>{item.unitTypeString}</Text>
              <Text style={styles.tableCell}>{item.taxPrice}</Text>
              <Text style={styles.tableCell}>{item.taxRate}</Text>
              <Text style={styles.tableCell}>{item.totalPrice}</Text>
            </View>
          ))}
        </View>

        <View style={styles.footer}>
            <Text style={styles.text}>Açıklama: {data?.description}</Text>
          <View>
            <Text style={styles.text}>
              Ara Toplam: {data?.price} {data?.currencyName}
            </Text>
            {data?.lineDiscounts > 0 && (
              <Text style={styles.text}>
                İskonto: {data?.lineDiscounts} {data?.currencyName}
              </Text>
            )}
            <Text style={styles.text}>
              KDV: {data?.taxPrice} {data?.currencyName}
            </Text>
            <Text style={styles.text}>
              Toplam: {data?.totalPrice} {data?.currencyName}
            </Text>
          </View>
        </View>

        <View style={styles.signatorySection}>
          <View style={styles.signatory}>
            <Text style={styles.signatureText}>Hazırlayan</Text>
            <Text style={styles.text}>{data?.creator}</Text>
          </View>
          <View style={styles.signatory}>
            <Text style={styles.signatureText}>Kontrol Eden</Text>
            <Text style={styles.text}>{data?.controllerUser}</Text>
          </View>
          <View style={styles.signatory}>
            <Text style={styles.signatureText}>Onaylayan</Text>
            <Text style={styles.text}>{data?.approvingUser}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default OfferDetailPdf;
